export const serializeError = (error: Error) => {
  try {
    return JSON.stringify(error, Object.getOwnPropertyNames(error));
  } catch {
    return '';
  }
};
